module.exports = __webpack_public_path__ + "img/table-layout.28db2e34.svg";